import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { finalize, takeUntil } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  GetMenuByTitleDto,
  HelpFileTypes,
} from 'src/app/core/api/models';
import { MenusService } from 'src/app/core/api/services';
import { AppConfigService } from 'src/app/core/services/config.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { ImageGalleryComponent } from 'src/app/shared/components/image-gallery/image-gallery.component';
import { BasePageComponent } from '../base/components/base-page.component';

@Component({
    selector: 'app-help-page',
    templateUrl: './help-page.component.html',
    standalone: false
})
export class HelpPageComponent extends BasePageComponent {
  //#region properties
  pageName = 'help';
  model: GetMenuByTitleDto = {};
  helpTitle: string = 'pages.help.title';
  preloadingRowCount = [...Array(6).keys()];
  apiUrl: string = AppConfigService.config.apiUrl;
  HelpFileTypesEnumValues: GetEnumValuesDto[] = [];

  @Input('title') title: string;
  @Input('menuTitle') menuTitle;

  @Output() hidePage = new EventEmitter<boolean>();

  currentService = inject(MenusService);
  dialogService = inject(DialogService);

  get helpFileType() {
    return HelpFileTypes;
  }

  categorizedFiles: any;

  //#endregion

  //#region init methods

  ngOnInit() {
    this.getPageHelp();
    this.getEnumsValues();
  }

  getEnumsValues() {
    this.getEnumValuesApi('HelpFileTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.HelpFileTypesEnumValues = values));
  }

  //#endregion

  //#region api
  getPageHelp() {
    this.loading = true;

    this.menuTitle =
      this.menuTitle.charAt(0).toUpperCase() + this.menuTitle.slice(1);

    this.currentService
      .menusGetMenuByTitle({ title: this.menuTitle })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response) => {
        if (response.statusCode == 200 && response.isSucceed) {
          this.model = response.data;
          this.onCategorizedFiles();
        }
      });
  }
  //#endregion

  onCategorizedFiles() {
    this.categorizedFiles = Object.values(HelpFileTypes)
      .filter((type) => typeof type === 'number') // فقط مقادیر عددی را نگه داریم
      .map((type) => ({
        type,
        files: this.model.menuHelps.filter((file) => file.type === type),
      }));
  }

  downloadFile(fileUrl: string) {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = fileUrl; // مسیر فایل
    link.click(); // اجرای دانلود
  }

  onOpenImageGalley(currentImage: string) {
    const images = this.categorizedFiles.filter(
      (item) => item.type === HelpFileTypes.Image
    );

    this.dialogService.openModal({
      component: ImageGalleryComponent,
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      class: 'image-galley',
      data: {
        images: images[0]?.files,
        currentImage,
      },
    });
  }

  onHidePage() {
    this.hidePage.emit(true);
  }
}
